import React, { useState } from 'react';
import './LandingPage.css';

const VideosPage = ({ navigateTo, playVideo }) => {
  const [filter, setFilter] = useState('all');

  // Extended video data
  const allVideos = [
    {
      id: 1,
      title: "Understanding Uniswap v4 Hooks in 60 Seconds",
      views: "12.4K",
      timestamp: "2 days ago",
      platform: "tiktok",
      category: "beginner",
      url: "https://tiktok.com",
      description: "Quick explanation of Uniswap v4 hooks and how they revolutionize DeFi"
    },
    {
      id: 2,
      title: "How Unichain Changes Everything for DEX Liquidity",
      views: "8.7K",
      timestamp: "4 days ago",
      platform: "youtube",
      category: "intermediate",
      url: "https://youtube.com",
      description: "Deep dive into Unichain and its impact on DEX liquidity"
    },
    {
      id: 3,
      title: "Flash Loans on Uniswap v4 Explained",
      views: "15.2K",
      timestamp: "1 week ago",
      platform: "tiktok",
      category: "advanced",
      url: "https://tiktok.com",
      description: "Flash loans made simple with real-world examples"
    },
    {
      id: 4,
      title: "Unichain vs Layer 2s: What's the Difference?",
      views: "10.1K",
      timestamp: "1 week ago",
      platform: "youtube",
      category: "intermediate",
      url: "https://youtube.com",
      description: "Comparing Unichain with other Layer 2 solutions"
    },
    {
      id: 5,
      title: "MEV Protection with Uniswap v4",
      views: "6.2K",
      timestamp: "2 weeks ago",
      platform: "youtube",
      category: "advanced",
      url: "https://youtube.com",
      description: "How Uniswap v4 hooks can protect against MEV"
    },
    {
      id: 6,
      title: "Liquidity Provision 101",
      views: "18.9K",
      timestamp: "3 weeks ago",
      platform: "tiktok",
      category: "beginner",
      url: "https://tiktok.com",
      description: "Basic guide to becoming a liquidity provider"
    }
  ];

  const filteredVideos = filter === 'all' ? allVideos : allVideos.filter(video => video.category === filter);

  return (
    <div className="app">
      {/* Header */}
      <header>
        <div className="container header-content">
          <h1 className="logo" onClick={() => navigateTo('home')} style={{cursor: 'pointer'}}>
            <span className="green">internet</span>
            <span className="purple">money</span>
            <span className="yellow">is</span>
            <span className="blue">serious</span>
            <span className="pink">.business</span>
          </h1>
          
          <nav className="main-nav">
            <a href="#" onClick={(e) => { e.preventDefault(); navigateTo('home'); }} className="nav-link">Home</a>
            <a href="#" onClick={(e) => { e.preventDefault(); navigateTo('videos'); }} className="nav-link active">Videos</a>
            <a href="#" onClick={(e) => { e.preventDefault(); navigateTo('learn'); }} className="nav-link">Learn</a>
            <a href="#" onClick={(e) => { e.preventDefault(); navigateTo('about'); }} className="nav-link">About</a>
          </nav>
          
          <button className="subscribe-btn" onClick={() => navigateTo('home')}>
            Subscribe
          </button>
        </div>
      </header>

      {/* Videos Page Content */}
      <section className="page-content">
        <div className="container">
          <h1 style={{marginTop: '2rem', marginBottom: '1rem'}}>All Videos</h1>
          
          {/* Filter Buttons */}
          <div className="filter-buttons" style={{marginBottom: '2rem'}}>
            <button 
              onClick={() => setFilter('all')}
              className={`tab-btn ${filter === 'all' ? 'active' : ''}`}
              style={{marginRight: '1rem'}}
            >
              All Videos
            </button>
            <button 
              onClick={() => setFilter('beginner')}
              className={`tab-btn ${filter === 'beginner' ? 'active' : ''}`}
              style={{marginRight: '1rem'}}
            >
              Beginner
            </button>
            <button 
              onClick={() => setFilter('intermediate')}
              className={`tab-btn ${filter === 'intermediate' ? 'active' : ''}`}
              style={{marginRight: '1rem'}}
            >
              Intermediate
            </button>
            <button 
              onClick={() => setFilter('advanced')}
              className={`tab-btn ${filter === 'advanced' ? 'active' : ''}`}
            >
              Advanced
            </button>
          </div>

          {/* Videos Grid */}
          <div className="video-grid">
            {filteredVideos.map(video => (
              <div key={video.id} className="video-card" onClick={() => playVideo(video)} style={{cursor: 'pointer'}}>
                <div className="video-thumbnail">
                  <div className="play-overlay">▶</div>
                  <div className="platform-badge">
                    {video.platform === 'youtube' ? 'YouTube' : 'TikTok'}
                  </div>
                  <div className="category-badge" style={{
                    position: 'absolute',
                    top: '10px',
                    left: '10px',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '0.7rem',
                    backgroundColor: video.category === 'beginner' ? '#green' : 
                                   video.category === 'intermediate' ? '#orange' : '#red',
                    color: 'white'
                  }}>
                    {video.category}
                  </div>
                </div>
                <div className="video-info">
                  <h4 className="video-title">{video.title}</h4>
                  <p style={{fontSize: '0.9rem', color: '#666', margin: '0.5rem 0'}}>
                    {video.description}
                  </p>
                  <div className="video-meta">
                    <span>{video.views} views</span>
                    <span>{video.timestamp}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer style={{marginTop: '3rem'}}>
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <h2 className="logo">
                <span className="green">internet</span>
                <span className="purple">money</span>
                <span className="yellow">is</span>
                <span className="blue">serious</span>
                <span className="pink">.business</span>
              </h2>
              <p>DeFi education in bite-sized videos</p>
            </div>
            
            <div className="footer-links">
              <a href="https://youtube.com/@internetmoneyisserious" target="_blank" rel="noopener noreferrer">YouTube</a>
              <a href="https://tiktok.com/@internetmoneyisserious" target="_blank" rel="noopener noreferrer">TikTok</a>
              <a href="https://twitter.com/imseriousbiz" target="_blank" rel="noopener noreferrer">Twitter</a>
              <a href="https://discord.gg/defi" target="_blank" rel="noopener noreferrer">Discord</a>
              <a href="#" onClick={(e) => { e.preventDefault(); navigateTo('about'); }}>Contact</a>
            </div>
          </div>
          
          <div className="copyright">
            &copy; {new Date().getFullYear()} internetmoneyisserious.business | Not financial advice
          </div>
        </div>
      </footer>
    </div>
  );
};

export default VideosPage;